import { useMemo } from 'react';
import { useSelector } from 'react-redux';

type TAuthState = {
	isSuccess: boolean;
	isDemoUser: boolean;
	userId: string;
	email: string;
	nick: string;
	registrationDate: Date | null;
	isLoading: boolean;
	isFromJoiAI: boolean;
};

import { useAuthenticateQuery } from '~services/api/auth';
import {
	getIsDemoUser,
	getIsFromJoiAI,
	getUserEmail,
	getUserId,
	getUserNick,
	getUserRegistrationDate,
} from '~store/auth/authSlice';

export const useSession = () => {
	const { isSuccess, isLoading } = useAuthenticateQuery(undefined, {});
	const email = useSelector(getUserEmail);
	const userId = useSelector(getUserId);
	const isDemoUser = useSelector(getIsDemoUser);
	const isFromJoiAI = useSelector(getIsFromJoiAI);
	const nick = useSelector(getUserNick);
	const registrationDate = useSelector(getUserRegistrationDate);

	const result: TAuthState = useMemo(
		() => ({
			isSuccess,
			userId: userId || '',
			email,
			isDemoUser,
			nick,
			registrationDate,
			isLoading,
			isFromJoiAI,
		}),
		[
			isSuccess,
			userId,
			email,
			isDemoUser,
			nick,
			registrationDate,
			isLoading,
			isFromJoiAI,
		]
	);
	return result;
};
